import { useState } from "react"
import { useEffect } from "react"
import { useMyInput } from "../ValidateForm"
import MyDatePicker from "../../../UI/form/datePicker/MyDatePicker"

const DateFieldValidate = ({ 
    value, setValue, label, forciblyValue, forciblyError, setValidate, minDateType, maxDateType,
    required = false, validates = {} 
 }) => {

    // console.log('value 111', value)

    const [error, setError] = useState('')
    const [validatesTemp, setValidatesTemp] = useState(validates)

    const fieldValidate = useMyInput('', validatesTemp)

    // визначаємо значення для відображення (пріоритет: forciblyValue > value)
    const displayValue = forciblyValue ?? value ?? ''
    // console.log('displayValue', displayValue)

    useEffect(() => {
        if (required) {
            setValidatesTemp({...validates, isEmpty: true})
        } else {
            setValidatesTemp(validates)
        }
    }, [required])

    // useEffect(() => {
    //     if (value) {
    //         fieldValidate.onChange(value)
    //         fieldValidate.onBlur()
    //     } 
    //     // else { // Убрал, так как в предложении ВУСО в ОСАГО было вечное обновление
    //     //     fieldValidate.onChange('')
    //     // }
    // }, [value])

    // оновлюємо валідатор тільки якщо displayValue змінився
    useEffect(() => {
        if (displayValue !== fieldValidate.value) {
            fieldValidate.onChange(displayValue)
            fieldValidate.onBlur()
        }
    }, [displayValue])
    
    // useEffect(() => {
    //     setValueField()
    // }, [fieldValidate.value])

    useEffect(() => {
		updateError()
	}, [fieldValidate.errors])

    useEffect(() => {
        updateValidate()
    }, [fieldValidate.isInputValid, error, required])

    // const setValueField = () => {
    //     setValue(fieldValidate.value)
    // }

    const updateValidate = () => {
		if (setValidate) {
            if (
				(fieldValidate.isInputValid || !required) && !error
			) {
                setValidate(true)
            } else {
                setValidate(false)
            }
        }
	}

    const updateError = () => {
		let errorTemp = ''

		if (forciblyError) { // Если принудительная ошибка, то выводить ее
			errorTemp = forciblyError
		} else if (!required && !fieldValidate.value) { // Если поле не обязательное и не заполненное, то без ошибки
			errorTemp = ''
		} else if (required && !fieldValidate.value) { // Если поле обязательное и нет значения
            errorTemp = 'Поле не може бути порожнім'
        } else if (fieldValidate && fieldValidate.errors) {
			const errors = fieldValidate.errors
			for (const i in errors) {
				if (errors[i]) {
					// console.log('errors[i]', errors[i])
					errorTemp = errors[i]
					break
				}
			}
		}

		setError(errorTemp)
	}

  return (
    <MyDatePicker
		labelText={label}
        field={{
            ...fieldValidate,
            value: displayValue, // 👈 керуємо value тільки з пропсів
            onChange: (val) => {
                setValue && setValue(val) // міняємо наверху
                fieldValidate.onChange(val) // валідатор бачить зміни
            }
        }}

		// value={fieldValidate.value}
		onBlur={e => fieldValidate.onBlur(e)}
		// onChange={date => fieldValidate.onChange(date)}
		// isError={fieldValidate.dateVidError}
		isError={error}
		isDirty={fieldValidate.isDirty}
		// error={fieldValidate.errors.isDateVid ? fieldValidate.errors.isDateVid : ''}
		error={error}
		minDateType={minDateType}
		maxDateType={maxDateType}
		isDisable={false}
	/>
  )
}

export default DateFieldValidate